/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { Layout } from '@ssense/ui-component-library';
import { connect } from 'react-redux';
import { UserType } from '../validation';
import i18n from '../i18n';
import indexRoutes from '../routes/index';
import sideBarRoutes from '../routes/sidebar';
import PrivateRoute from '../components/PrivateRoute';
import MyProfileMenuLink from '../components/AppLayout/MyProfileMenuLink';
import MySettingsMenuLink from '../components/AppLayout/MySettingsMenuLink';
import LogoutMenuLink from '../components/AppLayout/LogoutMenuLink';
import AppTitleLink from '../components/AppLayout/AppTitleLink';

class AppContainer extends Component {
  filterRoutes(routes) {
    const {
      flags,
      user,
    } = this.props;
    const featureFlagFilteredRoutes = routes.filter(route => !route.featureFlag || flags[route.featureFlag]);
    return featureFlagFilteredRoutes.filter(route => !route.scopes || (user.scopes && route.scopes.some((role) => user.scopes.includes(role))));
  }

  render() {
    const {
      user
    } = this.props;

    // we don't want to pass the scopes around unnecessarily
    const userNoScopes = { ...user };
    delete userNoScopes.scopes;

    const employeeChipMenuItems = [
      <MyProfileMenuLink />,
      <MySettingsMenuLink />,
      <LogoutMenuLink />,
    ];

    const childRoutes = (
      <Switch>
        {indexRoutes.map((route, index) => {
          if (route.public) {
            return <Route
              path={route.path}
              component={route.component}
              key={index}
              exact={route.exact}
            />
          }
          return <PrivateRoute
            route={route}
            path={route.path}
            key={index}
            exact={route.exact}
          />
        })}
      </Switch>
    );

    return <Layout
      routes={this.filterRoutes(sideBarRoutes)}
      title={i18n.t('appTitle')}
      childRoutes={childRoutes}
      userInfo={userNoScopes}
      menuItemsCustom={employeeChipMenuItems}
      link={<AppTitleLink />}
      isAuthEnabled // this must be passed as true in order for the user chip to be displayed
    />
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

AppContainer.propTypes = {
  flags: PropTypes.objectOf(PropTypes.bool).isRequired,
  user: UserType.isRequired,
}

export { AppContainer as AppContainerNoConnect }
export default withLDConsumer()(connect(mapStateToProps)(AppContainer));
